<template>
    <v-card :loading="loading" width="800">
        <template slot="progress">
            <v-progress-linear color="deep-purple" height="10" indeterminate></v-progress-linear>
        </template>

        <v-card-title class="mb-1 pb-1 blue--text text--darken-3">
            {{ RoomRate.roomName }}
        </v-card-title>

        <v-card-text class="mb-0  pb-0">
            <v-row class="mx-0" no-gutters>
                <v-col md="4">

                    <v-carousel hide-delimiters height="250" width="250">
                        <v-carousel-item v-for="(item, i) in RoomRate.roomImages" :key="i" :src="item.urlImage"
                            reverse-transition="fade-transition" transition="fade-transition"></v-carousel-item>
                    </v-carousel>

                </v-col>

                <v-col md="8">
                    <v-subheader>Description</v-subheader>
                    <v-row no-gutters>
                        <v-col class="mx-2 px-2">
                            <div>{{ roomDescription }}</div>
                        </v-col>
                    </v-row>
                    <v-divider></v-divider>
                    <v-subheader>Amenities</v-subheader>
                    <v-row no-gutters>
                        <v-col cols="12" class="mx-2 px-2" v-for="(item,iitem) in amenities" :key="iitem + 'amenity'">
                            <div>*{{ item.description }}</div>
                        </v-col>
                    </v-row>
                </v-col>
            </v-row>
        </v-card-text>
        <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" text @click="dialogMoreInformation">
                Close
            </v-btn>
        </v-card-actions>
    </v-card>
</template>
  
<script>
import moment from "moment";
export default {
    props: {
        RoomRate: {
            type: Object,
            require: true,
        },
    },
    data: () => ({
        loading: false,
        selection: 1,
        items: [],
        selectedUnit: 1,
    }),

    methods: {
        dialogMoreInformation: function () {
            this.$emit('close', false);
        }
    },
    computed: {
        roomDescription: function () {
            let name = this.RoomRate.description;
            // let name = this.RoomRate.priceList[0].hotDealDescription;
            return name;
        },
        amenities: function () {
            let list = this.RoomRate.beAmenities;
            return list;
        },
    },
};
</script>